module.exports = __webpack_public_path__ + "static/media/bpCarousel.500cc475.jpg";